<template>
  <v-select
    :label="label"
    :items="list"
    v-model="value"
    item-text="name"
    item-value="id"
    :multiple="multiple"
    chips
    :clearable="clearable"
    :menu-props="{ maxHeight: 'auto' }"
    :hint="hint"
    :persistent-hint="persistentHint"
    :small-chips="smallChips"
    :loading="loading"
  >
    <template slot="selection" slot-scope="{ item, parent, selected }">
      <v-chip
        @input="parent.selectItem(item)"
        :selected="selected"
        :key="item.id"
        :close="multiple"
        :small="smallChips"
      >
        <v-avatar>
          <img v-if="item.photo" :src="item.photo"/>
          <v-icon v-else v-html="item.avatarIcon ? item.avatarIcon : 'mdi-emoticon-neutral'"></v-icon>
        </v-avatar>
        {{ item.fullname ? item.fullname : item.name }}
      </v-chip>
    </template>
    <template slot="item" slot-scope="{ index, item }">
      <template v-if="typeof item !== 'object'">
        <v-list-tile-content v-text="item"></v-list-tile-content>
      </template>
      <template v-else>
        <v-list-tile-avatar>
          <img v-if="item.photo" :src="item.photo"/>
          <v-icon v-else v-html="item.avatarIcon ? item.avatarIcon : 'mdi-emoticon-neutral'"></v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.fullname ? item.fullname : emptyPost }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="item.name" v-html="item.name"></v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
    </template>
  </v-select>
</template>

<script>

import { debounce } from 'lodash'
import apiContractors from './api/api.js'

/**
 *
 *
 */
export default {

  name: 'DBeingSelector',

  props: {

    label: {
      type: String,
      required: true
    },

    hint: {
      type: String,
      required: true
    },

    ids: {
      type: Array,
      required: false,
      default: () => []
    },

    postsIds: {
      type: Array,
      required: false,
      default: () => []
    },

    containersIds: {
      type: Array,
      required: false,
      default: () => []
    },

    multiple: {
      type: Boolean,
      required: false,
      default: false
    },

    clearable: {
      type: Boolean,
      required: false,
      default: true
    },

    persistentHint: {
      type: Boolean,
      required: false,
      default: false
    },

    smallChips: {
      type: Boolean,
      required: false,
      default: false
    },

    useFaker: {
      type: Boolean,
      required: false,
      default: false
    },

    emptyPost: {
      type: String,
      required: false,
      default: 'Назначение на пост отсутствует'
    },

    defaultId: {
      type: String,
      required: false,
      default: null
    },
  },

  /**
   *
   *
   */
  data() {

    return {

      list: [],

      value: null,

      loading: false
    }
  },

  /**
   *
   *
   */
  computed: {

    fakeAvatar: function() {
      return this.$store.getters[ 'app/faker/avatar' ]()
    },
    fakeName: function() {
      return this.$store.getters[ 'app/faker/fullname' ]()
    }
  },

  /**
   *
   *
   */
  watch: {

    ids: function () {
      this.debouncedLoadData()
    },

    postsIds: function () {
      this.debouncedLoadData()
    },

    containersIds: function () {
      this.debouncedLoadData()
    },

    value: function () {
      this.$emit( 'input', this.value )
    },

    defaultId( value ) {
      this.value = value
    }
  },

  /**
   *
   *
   */
  created() {
    this.debouncedLoadData = debounce( this.loadPosts, 250, { 'maxWait': 500 } )
  },

  /**
   *
   *
   */
  mounted() {
    this.loadPosts()
  },

  /**
   *
   *
   */
  methods: {

    /**
     * Загрузка списка постов.
     *
     */
    loadPosts: function () {

      this.list = []
      this.loading = true

      return apiContractors.getPosts( this.containersIds, this.postsIds )
        .then( response => {

          if ( !Array.isArray( response.posts_data ) ) {
            return false
          }

          let posts = response.posts_data

          const postsIds = posts.map( item => item.id )

          apiContractors.getAccounts( postsIds )
            .then( accounts => {
              this.list = this.getPosts( posts, accounts )
            } )
        } )
        .catch( error => {
          console.error( error )
        } )
        .finally( () => {
          this.loading = false
        } )
    },

    /**
     * Получение списка постов.
     *
     */
    getPosts( posts, accounts ) {

      if ( !Array.isArray( posts ) ) {
        return []
      }

      if ( typeof accounts !== 'object' ) {
        return [ ...posts ]
      }

      return posts.map( post => {

        let account = accounts[ post.id ]

        if ( account ) {
          post.fullname = this.getAccountName( account )
          post.photo = this.getAccountPhotoUrl( account )
        }

        return post
      } )
    },

    /**
     * Получение имени пользователя.
     *
     * @param account
     * @returns {String}
     */
    getAccountName( account ) {
      return account.fullname
    },

    /**
     * Получение ссылки на фото пользователя.
     *
     * @param account
     * @returns {*}
     */
    getAccountPhotoUrl( account ) {

      if ( account.photo && account.photo.indexOf( 'http' ) < 0 && account.photo.indexOf( 'base64' ) < 0 ) {
        return '/disk/d/' + account.photo
      }

      return null
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/BeingSelector/src/component.vue